const intro = {
  ko: {
    main: '풍크트',
    sub: '',
    text: '는 디자인 스튜디오 ',
    studio: '피칸트',
    studioSub: '',
    suffix: '의 구성원들이 만드는 다양한 사이드 프로젝트를 담는 곳입니다. 좋아하는 것, 재미있는 것, 지나치고 싶지 않은 것들이 모입니다.'
  },
  en: {
    main: 'Punkt',
    sub: ' ',
    text: 'is a place that captures various side projects created by the design studio ',
    studio: 'Pikant',
    studioSub: ' ',
    suffix: '. It gathers things we like, interesting things, and things we don\'t want to miss.'
  }
};

const projects = [
      {
    id: 12,
    name: { ko: '식물 장례식', en: 'Plant Funeral' },
    thumbnail: '12/0.png',
    text: { ko: '키우던 식물이 죽었던 경험을 여러 번 겪었던 작업자 강민정은 그때마다 바싹 마른 식물들이 곧바로 쓰레기 봉투 속으로 버려지는 모습에 마음이 쓰였습니다. 식물의 죽음에도 적절한 형식의 애도가 필요하다는 생각에, 죽은 식물을 위한 장례 절차를 소개하는 소책자를 만들었습니다.', en: 'Having experienced the death of plants she had been caring for on multiple occasions, Kang Minjeong found herself troubled each time by the sight of their dried-out bodies being discarded straight into trash bags. Believing that the death of a plant, too, deserves an appropriate form of mourning, she created a small booklet that introduces a funeral ritual for deceased plants.' },
    details: {
      Year: { ko: '2025', en: '2025' },
      Category: { ko: '책', en: 'Book' },
      Link: { url: 'https://punkt.kr/patterns/', content: { ko: '', en: '' }  },
      Design: {
        people: [
          {
            name: { ko: '강민정', en: 'Minjeong Kang' },
            url: 'https://instagram.com/minaffect'
          }
        ]
      }
    },
    images: [

      { type: 'image', src: '12/1.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1152752133?background=1' },
      { type: 'image', src: '12/2.jpg' },
      { type: 'image', src: '12/3.jpg' },
      { type: 'image', src: '12/4.jpg' },
      { type: 'image', src: '12/5.jpg' },

    ]
  },
    {
    id: 11,
    name: { ko: '유령고양이의 두려움과 해골새의 즐거움', en: 'ghost cat’s fear and skull bird’s joy' },
    thumbnail: '11/0.png',
    text: { ko: '이미 유령이 된 고양이는 무엇을 두려워하고, 뼈밖에 남지 않은 새는 무엇을 즐거워할까요? 두 권의 책이 Z자 형태로 연결되어 있어서 한쪽 면에서는 『유령고양이의 두려움』을, 반대쪽 면에서는 『해골새의 즐거움』을 읽을 수 있습니다. 으스스하지만 어쩐지 마음이 쓰이는 이야기를 만나보세요.', en: 'What does a cat fear after it has already become a ghost? And what delights a bird that has nothing left but its bones? These two stories are bound together in a Z-fold format: one side reads Ghost Cat’s Fear, and the other side reads Skull Bird’s Joy. Eerie, yet somehow tender — come meet these strange little stories that linger in the heart.' },
    details: {
      Year: { ko: '2025', en: '2025' },
      Category: { ko: '책', en: 'Book' },
      Link: { url: 'https://smartstore.naver.com/punktstore/', content: { ko: '스마트스토어', en: 'go to store' } },
       Design: {
        people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [
              { type: 'image', src: '11/2.jpg' },
         { type: 'image', src: '11/1.jpg' },
       { type: 'image', src: '11/3.jpg' },
              { type: 'image', src: '11/5.jpg' },
                     { type: 'image', src: '11/6.jpg' },
                            { type: 'image', src: '11/7.jpg' },

    ]
  },
    {
    id: 10,
    name: { ko: '여행하는 이야기들', en: 'Traveling Stories' },
    thumbnail: '10/0.png',
    text: { ko: '3개로 나뉜 페이지들을 넘기며 여러 이야기 속 문장들을 직접 조합해 볼 수 있는 책입니다. 다섯 개의 테마인 인물, 방, 음식, 합주, 감정으로 묶인 문장들을 마음가는 대로 옮겨가면서 새로운 이야기를 만나보세요.', en: 'This book lets you flip through three split pages and create your own combinations of sentences drawn from different stories.Sentences are grouped into five themes—characters, rooms, food, ensemble, and emotions—and you can move them around freely to discover new narratives.' },
    details: {
      Year: { ko: '2025', en: '2025' },
      Category: { ko: '책', en: 'Book' },
      Link: { url: 'https://smartstore.naver.com/punktstore/', content: { ko: '스마트스토어', en: 'go to store' }  },
      Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [

      { type: 'image', src: '10/1.jpg' },
      { type: 'image', src: '10/3.jpg' },
       { type: 'image', src: '10/4.jpg' },
        { type: 'image', src: '10/5.jpg' },
         { type: 'image', src: '10/6.jpg' },
         { type: 'image', src: '10/7.jpg' },

    ]
  },
    {
    id: 9,
    name: { ko: '철도와 나', en: 'The Railway and Me' },
    thumbnail: '09/0.png',
    text: { ko: '독일에서 미대 유학 후 작가 활동을 하는 K는 평소 기차를 자주 탑니다. 하지만 연착과 취소가 잦기로 악명이 높은 독일 철도 앞에서 번번이 좌절하죠. 그때마다 K가 할 수 있는 건, 인스타그램 스토리 업로드 뿐입니다. 『철도와 나』에는 K가 인스타그램에 장장 3년에 걸쳐 업로드한 분노와 해탈의 스토리가 담겼습니다. 네온 핑크 별색을 사용해 열차의 잦은 지연과 K의 분노가 조금이라도 더 아름답게 보이도록 만들었습니다.', en: 'K, an artist who studied fine art in Germany and continues to work there, takes the train frequently. Yet she is repeatedly thwarted by the German railway system, notorious for its chronic delays and cancellations. Each time, the only thing K can do is post an Instagram Story.Railways and Me gathers three years’ worth of these Instagram Stories—records of anger and, eventually, resignation. Printed with a neon pink spot color, the book seeks to render the trains’ relentless delays, and K’s mounting frustration, just a little more beautiful.' },
    details: {
      Year: { ko: '2025', en: '2025' },
      Category: { ko: '책', en: 'Book' },
      Link: { url: 'https://smartstore.naver.com/punktstore/', content: { ko: '스마트스토어', en: 'go to store' }  },
      Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [

      { type: 'image', src: '09/1.jpg' },
      { type: 'image', src: '09/2.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1152760265?background=1' },
      { type: 'image', src: '09/3.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1152764914?background=1' },
      { type: 'image', src: '09/4.jpg' },

    ]
  },
  {
    id: 8,
    name: { ko: '패턴들', en: 'Patterns' },
    thumbnail: '08/0.gif',
    text: { ko: '직접 작은 세상을 만드는 것을 좋아하는 작업자 최중원은 규칙과 무작위에 기대어 패턴이 태어나고 움직이는 사이트를 만들었습니다. 마음에 드는 패턴을 발견할 때까지 주사위를 굴리거나, 직접 수치를 조절해서 자신만의 패턴을 만들어 보세요.', en: 'Joongwon Choi, a creator who loves building miniature worlds, made a site where patterns are born and move, relying on a mix of rules and randomness. Roll the dice until you discover one you love, or adjust the parameters yourself to create a pattern that is uniquely yours.' },
    details: {
      Year: { ko: '2025', en: '2025' },
      Category: { ko: '책', en: 'Book' },
      Link: { url: 'https://punkt.kr/patterns/', content: { ko: '사이트로 가기', en: 'to the site' } },
      Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          }
        ]
      }
    },
    images: [

      { type: 'image', src: '08/1.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1072908373?background=1' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1072908815?background=1' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1072908823?background=1' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1072908831?background=1' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1072907840?background=1' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1072907617?background=1' },
      { type: 'image', src: '08/5.jpg' },

    ]
  },
  {
    id: 7,
    name: { ko: '문', en: 'Doors' },
    thumbnail: '07/0.png',
    text: { ko: '피칸트가 위치한 용산구 효창공원 근방에는 오랜 시절을 견뎌낸 다양한 건물이 여럿 있습니다. 이러한 오래된 건물 한켠에는 목적도 이름도 모를 크기마저 마음대로인 문들이 존재합니다. 이 영문모를 문에서 풍기는 신비로운 분위기가 효창공원의 매력이라 생각한 작업자 윤희경은 피칸트 주변 문들을 엮어 책으로 제작하였습니다.', en: 'In the vicinity of Hyochang Park, near where Pikant is located in Yongsan District, there are several buildings that have withstood the test of time. Tucked away among these ancient structures are doors of indeterminate purpose and size, whose origins are just as mysterious. Captivated by the mystical aura these enigmatic doors lend to the park, Heekyung Yoon compiled them into a book.' },
    details: {
      Year: { ko: '2025', en: '2025' },
      Category: { ko: '책', en: 'Book' },
      Link: { url: 'https://smartstore.naver.com/punktstore', content: { ko: '', en: '' } },
      Design: {
      people: [
          {
            name: { ko: '윤희경', en: 'Heekyung Yoon' },
            url: 'https://instagram.com/heekyunghee'
          }
        ]
      }
    },
    images: [
      { type: 'image', src: '07/1.jpg' },
      { type: 'image', src: '07/2.jpg' },
      { type: 'image', src: '07/3.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1074133540?background=1' },
      { type: 'image', src: '07/4.jpg' },
      { type: 'image', src: '07/5.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1074193811?background=1' },
      

    ]
  },
  {
    id: 6,
    name: { ko: '()없는 ()책', en: 'A ()less () Book' },
    thumbnail: '06/0.png',
    text: { ko: '작업자 최중원은 지인들이 보내준 닮은꼴 사진을 5년 전부터 모아 왔습니다. 운동선수, 모델, 스타트업 대표, 배우, 게임 속 캐릭터까지 다양한 분야와 매체의 26인의 사진을 작은 책으로 엮었습니다.', en: 'Choi Joongwon has been collecting lookalike photos sent by friends over the past five years. The collection, featuring 26 individuals from various fields and media—including athletes, models, startup founders, actors, and video game characters—has been compiled into a small book.' },
    details: {
      Year: { ko: '2024', en: '2024' },
      Category: { ko: '소책자', en: 'Booklet' },
      Link: { url: 'https://smartstore.naver.com/punktstore', content: { ko: '', en: '' } },
         Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          }
        ]
      }
    },
    images: [
      { type: 'image', src: '06/01.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1070245606?background=1' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/1072903617?background=1' },
      { type: 'image', src: '06/02.jpg' },
      { type: 'image', src: '06/03.jpg' },

    ]
  },

  // 이 위부터 new

  {
    id: 5,
    name: { ko: '나무 그림자 채집', en: 'Gathering Tree Shadows' },
    thumbnail: '05/0.png',
    text: { ko: '함부르크에서 채집한 나무 그림자들을 모아서 묶은 책입니다.', en: 'A book compiled of tree shadows collected in Hamburg.' },
    details: {
      Year: { ko: '2024', en: '2024' },
      Category: { ko: '단행본', en: 'Book' },
      Link: { url: 'https://smartstore.naver.com/punktstore', content: { ko: '스마트스토어', en: 'go to store' } },
            Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [

      { type: 'image', src: '05/01.jpg' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/990863776?background=1' },
      { type: 'image', src: '05/02.jpg' },
      { type: 'image', src: '05/03.jpg' },
      { type: 'image', src: '05/04.jpg' },
      { type: 'image', src: '05/05.jpg' },

    ]
  },
  // {
  //   id: 4,
  //   name: { ko: '유령고양이와 해골새', en: 'Ghost-Cat and Skeleton-Bird' },
  //   thumbnail: '04/0.png',
  //   text: { ko: '크리스마스 시즌을 맞아 유령 고양이와 해골 새가 등장하는 조금은 으스스한 엽서를 만들었습니다. ', en: '' },
  // details: {
  //     Year: { ko: '2024', en: '2024' },
  //     Category: { ko: '캐릭터', en: 'Character'},
  //     Link: { url: 'https://smartstore.naver.com/punktstore/products/11252961254', content: { ko: '스마트스토어', en: 'go to store' } }
  //   },
  //   images: [ 
  //     { type: 'image', src: '04/1.png' },
  //     { type: 'image', src: '04/2.png' },
  //     { type: 'image', src: '04/3.png' },

  //   //  // { src: '04/01.png', caption: { ko: '첫 번째 이미지 캡션', en: 'First image caption' } },
  //   //   { src: '04/01.png', caption: { ko: '첫 번째 이미지 캡션', en: 'First image caption' } },
  //   ]
  // },
  {
    id: 3,
    name: { ko: '아인말 슈톨렌, 비테', en: 'Einmal Stollen, bitte' },
    thumbnail: '03/0.png',
    text: { ko: '베를린에서 보낸 크리스마스를 떠올리며 쓴 단편소설 모음집입니다. 책에 등장하는 인물들은 도토리를 도둑맞은 다람쥐부터 단골 손님에게 슈톨렌을 팔고 싶은 빵집 점원까지 다양합니다. 흐리고 축축한 베를린의 겨울을 버틸 수 있게 해주는 크리스마스의 면면을 담았습니다.', en: 'A collection of short stories reminiscing Christmas spent in Berlin. The characters in the book range from a squirrel who got its acorns stolen to a bakery clerk who wants to sell stollen to regular customers. It captures the aspects of Christmas that help endure the gray and damp winter of Berlin.' },
    details: {
      Year: { ko: '2023', en: '2023' },
      Category: { ko: '단행본', en: 'Book' },
      Size: { ko: '110*140', en: '110*140' },
      Link: { url: 'https://smartstore.naver.com/punktstore', content: { ko: '스마트스토어', en: 'go to store' } },
      Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [
      { type: 'image', src: '03/01.jpg' },
      { type: 'image', src: '03/02.gif' },
      { type: 'image', src: '03/03.jpg' },
      { type: 'image', src: '03/04.jpg' },
      { type: 'image', src: '03/05.png' },
      { type: 'image', src: '03/06.jpg' },
      { type: 'image', src: '03/07.jpg' },
    ]
  },
  {
    id: 2,
    name: { ko: '이웃새의 새해 인사', en: 'Neighbirdhood' },
    thumbnail: '02/0.png',
    text: { ko: '2024년 새해를 맞아 만든 우리 주변의 다양한 새들을 만나볼 수 있는 웹 연하장입니다. 먹이 두 가지를 고르고 잠시 기다리면, 그 먹이를 찾아온 새 한 마리가 새해 인사를 전해줍니다.', en: 'A online New Year’s card created to celebrate 2024, featuring various birds from our surroundings. Choose two types of food and wait for a moment, and a bird that comes to find the food will deliver a New Year’s greeting.' },
    details: {
      Year: { ko: '2024', en: '2024' },
      Category: { ko: '웹 연하장', en: 'Website' },
      Link: { url: 'https://pikant.kr/birds', content: { ko: '새들 만나러 가기', en: 'to the site' } },
            Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [
      { type: 'vimeo', src: 'https://player.vimeo.com/video/986262795?background=1' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/986269469?background=1' },
      { type: 'image', src: '02/03.jpg' },
      { type: 'image', src: '02/04.jpg' },
         //{ src: '01/1.jpg', caption: { ko: '첫 번째 이미지 캡션', en: 'First image caption' } },
    ]
  },
  {
    id: 1,
    name: { ko: '케이크 연하장', en: 'New year\'s cake' },
    thumbnail: '01/0.png',
    text: { ko: '‘Decorate your New Year’s Cake’은 2023년 새해를 맞아 피칸트가 제작한 웹 연하장입니다. 다양한 케이크 시트와 재료, 장식물을 조합하면 총 4096종의 케이크를 만들 수 있습니다. 사이트 방문자가 케이크를 완성하면 피칸트가 전하는 새해 카드가 케이크의 배경에 나타납니다.', en: 'For the new year, Pikant has created a micro-website where users can decorate their own cake. By combining cake sheets and different decorations, a total of 4096 different cakes can be created. When the cake is finished, a New Year’s greeting from Pikant appers.' },
    details: {
      Year: { ko: '2018 ~', en: '2018 ~' },
      Category: { ko: '웹 연하장', en: 'Website' },
      Link: { url: 'http://pikant.kr/cake', content: { ko: '케이크 만들기', en: 'to the site' } },
            Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [
      { type: 'image', src: '01/1.jpg' },
      { type: 'image', src: '01/2.gif' }, // 캡션이 없는 이미지
      { type: 'image', src: '01/3.png' },
      // { type: 'lottie', src: 'https://lottie.host/embed/f0afe20f-0f21-4577-b897-479b36ca24bf/kZxn6Wa7BW.json' },
      { type: 'vimeo', src: 'https://player.vimeo.com/video/986212412?background=1' },
  
    ]
  },
   {
    id: 0,
    name: { ko: '이대로 괜찮을까', en: 'would it be okay' },
    thumbnail: '00/0.png',
    text: { ko: '피칸트의 두 디자이너는 함께 한국과 독일의 일상을 4컷 만화로 그려 인스타그램에 비정기적으로 연재하고 있습니다. 만화는 책으로도 제작되었습니다.', en: 
      'The two designers of Pikant draw the 4-cut cartoons of daily life in South Korea and Germany and publish them on Instagram at irregular intervals. Comics were also produced as books.'

     },
    details: {
      Year: { ko: '2023', en: '2023' },
      Category: { ko: '단행본/만화', en: 'Book/Comic' },
      Link: { url: 'http://instagram.com/would_it_be_okay', content: { ko: 'instagram', en: 'instagram' } },
            Design: {
           people: [
          {
            name: { ko: '최중원', en: 'Joongwon Choi' },
            url: 'https://instagram.com/choijoongwon'
          },
            {
            name: { ko: '송민선', en: 'Minsun Song' },
            url: 'https://instagram.com/miiiiinsun'
          }
        ]
      }
    },
    images: [
      { type: 'image', src: '00/01.jpg' },
      { type: 'image', src: '00/02.jpg' },
      { type: 'image', src: '00/03.jpg' },
      { type: 'image', src: '00/04.jpg' },
      { type: 'image', src: '00/05.jpg' },
      
  
    ]
  },

  
  // 다른 프로젝트 추가...
];

export { intro, projects };



//example for caption, lottie, vimeo

// images: [
//   { type: 'image', src: '01/1.jpg', caption: { ko: '첫 번째 이미지 캡션', en: 'First image caption' } },
//   { type: 'image', src: '01/2.jpg' }, // 캡션이 없는 이미지
//   { type: 'lottie', src: '<iframe src="https://lottie.host/embed/f0afe20f-0f21-4577-b897-479b36ca24bf/kZxn6Wa7BW.json" width="100%" height="auto" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' },
//   { type: 'vimeo', src: '<iframe src="https://player.vimeo.com/video/942232265?background=1" width="2500" height="1666" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="그룬트패턴모션"></iframe>' }
// ]